import TabPage from "./../factories/tab-page";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialog from "./../factories/bao-dialog";
import TranslateDialogViewModel from "./../factories/translate-dialog";
import BaseSearchPaging2 from "./../factories/search-paging2";

/**
 * WorkItem Type ViewModel
 */
class WorkItemType extends BaseSearchPaging2 {

    //#region Constructor

    /**
    * Constructor
    */
    public constructor(tabPage: TabPage) {
        super(tabPage);
        this.PermissionForward = "WorkItemTypeForward";
        this.PermissionBackward = "WorkItemTypeBackward";
    }

    //#endregion Constructor

    //#region Properties

    /**
     * Child tab for WorkItem Collection 
     */
    WorkItemCollectionWorkItemTypeTab: TabPage;

    /**
     * Child tab for WorkItem Tab
     */
    WorkItemTypeTab: TabPage;

    /**
     * Child tab for WorkItem Category 
     */
    WorkItemCategoryWorkItemTypeTab: TabPage;

    /**
     * Child tab for WorkItem Collection
     */
    WorkItemPriorityWorkItemTypeTab: TabPage;

    /**
    * Work Item Type Name 
    */
    WorkItemType: KnockoutComputed<any> = ko.pureComputed({
        read: () => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    return this.WorkItemType1();
                case 2:
                    return this.WorkItemType2();
                case 3:
                    return this.WorkItemType3();
                case 4:
                    return this.WorkItemType4();
                case 5:
                    return this.WorkItemType5();
            }
        },
        write: (value) => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    this.WorkItemType1(value);
                    break;
                case 2:
                    this.WorkItemType2(value);
                    break;
                case 3:
                    this.WorkItemType3(value);
                    break;
                case 4:
                    this.WorkItemType4(value);
                    break;
                case 5:
                    this.WorkItemType5(value);
                    break;
            }
        }
    });

    /**
    *  Work Item Type Description
    */

    Description: KnockoutComputed<any> = ko.pureComputed({
        read: () => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    return this.Description1();
                case 2:
                    return this.Description2();
                case 3:
                    return this.Description3();
                case 4:
                    return this.Description4();
                case 5:
                    return this.Description5();
            }
        },
        write: (value) => {
            switch (Bao.Session.Language.LanguageIndex()) {
                case 1:
                    this.Description1(value);
                    break;
                case 2:
                    this.Description2(value);
                    break;
                case 3:
                    this.Description3(value);
                    break;
                case 4:
                    this.Description4(value);
                    break;
                case 5:
                    this.Description5(value);
                    break;
            }
        }
    });

    /**
    *  Primary Key
    */
    WorkItemTypeId: KnockoutObservable<string> = ko.observable();

    /**
    *  Work Item Type Title in Deutsch language
    */
    WorkItemType1: KnockoutObservable<string> = ko.observable();

    /**
    * Work Item Type Title in English language 
    */
    WorkItemType2: KnockoutObservable<string> = ko.observable();

    /**
    * Work Item Type Title in français language
    */
    WorkItemType3: KnockoutObservable<string> = ko.observable();

    /**
    * Work Item Type Title in Romanian language 
    */
    WorkItemType4: KnockoutObservable<string> = ko.observable();

    /**
    * Work Item Type Title in Nederlands language 
    */
    WorkItemType5: KnockoutObservable<string> = ko.observable();

    /**
    * Work Item Type Description in Deutsch 
    */
    Description1: KnockoutObservable<string> = ko.observable();

    /**
    * Work Item Type Description in English 
    */
    Description2: KnockoutObservable<string> = ko.observable();

    /**
    * Work Item Type Description in français 
    */
    Description3: KnockoutObservable<string> = ko.observable();

    /**
    * Work Item Type Description in Romanian 
    */
    Description4: KnockoutObservable<string> = ko.observable();

    /**
    * Work Item Type Description in Nederlands 
    */
    Description5: KnockoutObservable<string> = ko.observable();

    /**
     * Work Item Type Client Route
     */
    ClientRoute: KnockoutObservable<string> = ko.observable();

    //#endregion Properties

    //#region Public Methods

    /**
    *  Validations
    */
    CompleteCheck = (): JQueryPromise<boolean> | boolean => {
        let completed: boolean;
        completed = true;
        if (Bao.Utils.String.IsNullOrWhitespace(this.WorkItemType())) {
            completed = false;
        }
        if (!completed) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return completed;
    }

    /**
     *  Init Url for Initialize page
     */
    public InitUrl(): string {
        return "WorkItemType/Init";
    }

    /**
     * Initialization 
     */
    init() {
        return $.when(super.init(), super.InitTabController(), Bao.Session.GetMessage("msgWorkItemCategoryTabTitle"),
            Bao.Session.GetMessage("msgWorkItemPriorityTabTitle"), Bao.Session.GetMessage("msgWorkItemCollectionTabTitle"), Bao.Session.GetMessage("msgWorkItemTypeTabTabTitle")).then(() => {

                this.WorkItemCollectionWorkItemTypeTab = new TabPage('workItemCollectionWorkItemTypeTab');
                this.WorkItemCollectionWorkItemTypeTab.IsClosable(false);
                this.WorkItemCollectionWorkItemTypeTab.Url('WorkItemCollectionWorkItemTypeTab');
                this.WorkItemCollectionWorkItemTypeTab.Title(Bao.Session.GetMessage("msgWorkItemCollectionTabTitle")());
                this.WorkItemCollectionWorkItemTypeTab.AutoSelect = true;
                this.TabController.AddTab(this.WorkItemCollectionWorkItemTypeTab);

                this.WorkItemTypeTab = new TabPage('WorkItemTypeTab');
                this.WorkItemTypeTab.IsClosable(false);
                this.WorkItemTypeTab.Url('WorkItemTypeTab');
                this.WorkItemTypeTab.Title(Bao.Session.GetMessage("msgWorkItemTypeTabTabTitle")());
                this.WorkItemTypeTab.AutoSelect = false;
                this.TabController.AddTab(this.WorkItemTypeTab);

                this.WorkItemCategoryWorkItemTypeTab = new TabPage('WorkItemCategoryWorkItemTypeTab');
                this.WorkItemCategoryWorkItemTypeTab.IsClosable(false);
                this.WorkItemCategoryWorkItemTypeTab.Url('WorkItemCategoryWorkItemTypeTab');
                this.WorkItemCategoryWorkItemTypeTab.Title(Bao.Session.GetMessage("msgWorkItemCategoryTabTitle")());
                this.WorkItemCategoryWorkItemTypeTab.AutoSelect = false;
                this.TabController.AddTab(this.WorkItemCategoryWorkItemTypeTab);

                this.WorkItemPriorityWorkItemTypeTab = new TabPage('WorkItemPriorityWorkItemTypeTab');
                this.WorkItemPriorityWorkItemTypeTab.IsClosable(false);
                this.WorkItemPriorityWorkItemTypeTab.Url('WorkItemPriorityWorkItemTypeTab');
                this.WorkItemPriorityWorkItemTypeTab.Title(Bao.Session.GetMessage("msgWorkItemPriorityTabTitle")());
                this.WorkItemPriorityWorkItemTypeTab.AutoSelect = false;
                this.TabController.AddTab(this.WorkItemPriorityWorkItemTypeTab);
            });
    }

    /**
     *Translate WorkItem Description Dialog
     */
    TranslateDescription = (): void => {
        let translateDialog = new TranslateDialogViewModel(this.Description1, this.Description2, this.Description3, this.Description4, this.Description5);
        translateDialog.Open().then(() => {
        });
    }

    /**
     *Translate WorkItem Type Dialog
     */
    TranslateWorkItemType = (): void => {
        let translateDialog = new TranslateDialogViewModel(this.WorkItemType1, this.WorkItemType2, this.WorkItemType3, this.WorkItemType4, this.WorkItemType5);
        translateDialog.Open().then(() => {
        });
    }

    //#endregion Public Methods

}
export default WorkItemType;